import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../Config";

export default function KlarnaCheckoutScreen() {
  const { orderId } = useParams();
  const [htmlSnippet, setHtmlSnippet] = useState("");

  useEffect(() => {
    const loadSnippet = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/klarna/start/${orderId}/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await res.json();
        setHtmlSnippet(data.html_snippet || "");
        console.log("📦 Klarna snippet carregado");
      } catch (err) {
        console.error("❌ Erro ao carregar Klarna snippet:", err);
      }
    };
    loadSnippet();
  }, [orderId]);

  return (
    <div className="container py-5">
      <h2 className="mb-4">Klarna Checkout</h2>
      <div dangerouslySetInnerHTML={{ __html: htmlSnippet }} />
    </div>
  );
}
